import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AircondUnit {
  title: string;
  basePrice: number;
  units: number;
}

interface AircondCalculatorProps {
  onCalculate: (services: { title: string; price: string }[]) => void;
}

const AircondCalculator = ({ onCalculate }: AircondCalculatorProps) => {
  const { t } = useTranslation();
  const unitTitles = t('calculators.aircond.units', { returnObjects: true }) as string[];

  const [units, setUnits] = useState<AircondUnit[]>([
    { title: unitTitles[0] || 'Penghawa Dingin : 1.0hp & 1.5hp', basePrice: 130, units: 0 },
    { title: unitTitles[1] || 'Penghawa Dingin : 2.0hp & 2.5hp', basePrice: 160, units: 0 },
    { title: unitTitles[2] || 'Penghawa Dingin : 3.0hp & ke atas', basePrice: 190, units: 0 }
  ]);

  const handleUnitChange = (index: number, value: number) => {
    const newUnits = [...units];
    newUnits[index].units = Math.max(0, value);
    setUnits(newUnits);

    const selectedUnits = newUnits.filter(unit => unit.units > 0);
    const services = selectedUnits.map(unit => ({
      title: `${unit.title} (${unit.units} ${t('calculators.aircond.unit')})`,
      price: `RM${(unit.basePrice * unit.units).toFixed(2)}`
    }));

    onCalculate(services);
  };

  return (
    <div className="space-y-4">
      {units.map((unit, index) => {
        const isSelected = unit.units > 0;

        return (
          <div 
            key={index} 
            className={`p-2 border rounded-md transition-colors ${
              isSelected ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
            }`}
          >
            <div className="flex items-center justify-between gap-1">
              <span className={`text-sm ${isSelected ? 'text-blue-700' : 'text-gray-700'}`}>
                {unit.title}
              </span>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  min="0"
                  value={unit.units || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    const numValue = value ? parseInt(value, 10) : 0;
                    handleUnitChange(index, numValue);
                  }}
                  className="border rounded w-12 text-center text-sm h-6"
                />
                <span className={`text-sm ${isSelected ? 'text-blue-700' : 'text-gray-500'}`}>
                  RM{unit.basePrice}{t('calculators.aircond.perUnit')}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AircondCalculator; 